<template>
    <div>

        <rkm-table
            :fields="fields"
            :items="data.model.atendimentos"
            hide-filters
            hide-pagination
            sort-by="nome"
        >

            <template v-slot:cell(nome)="{ item }">
                {{ item.nome }}
                <template v-if="item.nomeSocial">
                    <component :is="item.prefereNomeSocial ? 'strong' : 'span'">
                        ({{ item.nomeSocial }})
                    </component>
                </template>
            </template>

            <template v-slot:cell(dataNascimento)="row">
                {{ row.value | formatDate }}
            </template>

            <template v-slot:cell(cpf)="row">
                {{ row.value | formatCpf }}
            </template>

            <template v-slot:cell(cns)="row">
                {{ row.value | formatCns }}
            </template>

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    @click="open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                    :disabled="data.model.exportado"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
import Modal from './Modal'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository } from '@/mixins'

export default {
    components: {
        Modal
    },
    computed: {
        fields() {

            return [
                {
                    key: "nome",
                    label: "Nome",
                },
                {
                    key: "cpf",
                    label: "CPF",
                    class: "col-min",
                },
                {
                    key: "cns",
                    label: "CNS",
                    class: "col-min",
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    class: "col-min",
                },
                {
                    key: "localAtendimento",
                    label: "Local de atendimento",
                },
                {
                    key: "turno",
                    label: "Turno",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        },
    },
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns,
        formatCpf: formats.formatCpf,
    },
    methods: {
        open(item) {

            this.$refs.Modal.open(item)
        },
        destroy(item) {

            const index = this.data.model.atendimentos.findIndex(u => u.id === item.id)
            const destroy = async () => this.data.model.atendimentos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o atendimento?', destroy)
        },
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
    }
}
</script>